import { DataGrid, GridFooter } from '@mui/x-data-grid';
import CustomFooterTotal from './CustomFooterTotal';
import { Box } from '@mui/material';
import PrintToolbar from './GridToolbar';

export default function ReportGrid({ xRows, xColumns, xIsMIS = false }) {
  return (
    <Box sx={{ height: '100%', width: '100%' }}>
      <DataGrid
        rows={xRows}
        // getRowId={(row) => row.SrNo}
        columns={xColumns}
        rowHeight={30}
        headerHeight={40}
        sx={{
          border: 0,
          borderColor: 'primary.light',
          boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
          '& .MuiDataGrid-row:hover': {
            color: 'primary.main',
            cursor: 'pointer',
            fontWeight: 500
          }
        }}
        components={{
          Toolbar: PrintToolbar,
          Footer: xIsMIS ? CustomFooterTotal : GridFooter
        }}
        componentsProps={{
          toolbar: { rows: xRows }, // ✅ pass rows to toolbar
          footer: { rows: xRows },
          filterPanel: { sx: { maxWidth: '93vw' } }
        }}
        getRowClassName={(params) => 'mui-report-grid-row'}
      />
    </Box>
  );
}
